import { BUSINESS_UNIT } from '@/constants/businessUnit'
import { formatToCpf } from '@/utils/format/cpf'
import { formatPhonePT } from '@/utils/format/phone'

interface MemberSearchConfig {
  placeholder: string
  buttonLabel: string
  emptyMessage: string
  notFoundMessage: string
  initialMessage: string
  errorMessage: string
  formatValue: (value: string) => string
}

const defaultConfig: MemberSearchConfig = {
  placeholder: 'Insira o número do CPF',
  buttonLabel: 'Buscar participante',
  emptyMessage: 'O campo de CPF não pode estar vazio. Por favor, insira um número de CPF válido.',
  notFoundMessage: 'O CPF não foi localizado. Revise os dados inseridos novamente.',
  initialMessage: 'É necessário inserir o número de CPF para consultar um participante.',
  errorMessage: 'Ocorreu um erro ao buscar o participante. Tente novamente.',
  formatValue: formatToCpf
}

const memberSearchDictionary: Record<string, MemberSearchConfig> = {
  [BUSINESS_UNIT.GB]: defaultConfig,
  [BUSINESS_UNIT.VDBOT]: defaultConfig,
  [BUSINESS_UNIT.GBPT]: {
    placeholder: 'Insira o número de telefone',
    buttonLabel: 'Buscar participante',
    emptyMessage: 'O campo de telefone não pode estar vazio. Por favor, insira um número de telefone válido.',
    notFoundMessage: 'O telefone não foi localizado. Revise os dados inseridos novamente.',
    initialMessage: 'É necessário inserir o número de telefone para consultar um participante.',
    errorMessage: 'Ocorreu um erro ao buscar o participante. Tente novamente.',
    formatValue: formatPhonePT
  }
}

export const getMemberSearchConfig = (businessUnitValue: string | null | undefined): MemberSearchConfig =>
  memberSearchDictionary[businessUnitValue ?? ''] ?? defaultConfig

export type { MemberSearchConfig }
